import React, { useRef } from "react";
import clsx from "clsx";
import { Button, Form, TextField } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";
import { isFunction, refIsRequiredError } from "@util/utils";
import { MEMBER_NOTE_TYPE } from "@icoach/constants";

const SpecialBodyConditionDialog = React.forwardRef((props, ref) => {
	const { open, className, sourceData, onClose, refresh } = props;
	if (!open) return null;
	const { specialBodyCondition, memberID } = sourceData || {};
	const { postMemberProfileNotesApi } = useMemberProfileApi();

	const notesRef = useRef();

	const doMemberProfileNotesApi = async (memberID, params) => {
		let res = await postMemberProfileNotesApi(memberID, params);
		if (res) {
			isFunction(refresh) && refresh(params.notes);
			isFunction(onClose) && onClose();
		}
	};

	const handleSubmit = () => {
		if (!refIsRequiredError(notesRef)) {
			let params = {
				noteType: MEMBER_NOTE_TYPE.SPECIALBODYCONDITION,
				notes: notesRef.current && notesRef.current.getResult(),
			};
			doMemberProfileNotesApi(memberID, params);
		}
	};

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-65rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>身體特殊狀況</GradientColorHeader>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<TextField
							label="身體特殊狀況"
							ref={notesRef}
							key={specialBodyCondition}
							defaultValue={specialBodyCondition}
							InputProps={{ placeholder: "請輸入" }}
							rows="4"
							multiline
							fullWidth
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button type={"submit"} variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default SpecialBodyConditionDialog;
